import { z } from 'zod';
import I18N from '@leverege/i18n';
import { Attributes } from '@leverege/ui-attributes';
const {
  t
} = I18N.ns('molten.imagine.forms.validators.AlphaNumericValidator');
const ALPHA_REGEX = /^[0-9a-zA-Z\s]+$/;
const validator = value => {
  if (value == null) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.every(val => ALPHA_REGEX.test(val));
  }
  return ALPHA_REGEX.test(value);
};
export default {
  createFor(name, objectType, {
    molten,
    isArray = false
  }) {
    const attr = Attributes.getAttribute(name, objectType);
    const opts = {
      message: t('message', {
        name: attr?.displayName || 'Field'
      })
    };
    molten.addPlugin('AttributeValueValidator', {
      name,
      objectType,
      valueValidator: z.custom(validator, opts)
    });
  }
};